import { Component, OnInit, ViewChild } from '@angular/core';
import { GridBaseCase } from '../../grid/grid.base.case';
import { WebParameterContext } from '../../../../model/common';
import { Platform, IonInfiniteScroll } from '@ionic/angular';
import { HttpCustomerService } from 'src/service/httpcustomer.service';
import { CommonService } from 'src/service/common.service';
import { ActivatedRoute, Router } from '@angular/router';
import { MessageclientService } from '../../../../service/messageclient.service';
import { BaseCase } from '../../../basecase';
import { BaseModal } from '../../../../model/base';
declare var app;

@Component({
  selector: 'app-a2-sales-report',
  templateUrl: './a2-sales-report.component.html',
  styleUrls: ['./a2-sales-report.component.scss']
})
export class A2SalesReportComponent extends GridBaseCase {
  month: any = new Date();
  segmentVal: any = 0;
  typeout: any = null;
  searchDate = null;
  searcholdDate = null;
  dataArrayList: Array<any> = [];
  dataroDuctSeriesList: Array<any> = [];
  max: any;//当前日期
  @ViewChild(IonInfiniteScroll) infiniteScroll: IonInfiniteScroll;
  RecordCount: Number = 0;//列表总数量
  addobject: any = {};//多选
  pageName: string = null;
  tabsIndex: number = 0;
  tabsIndexdetail: any = "全部会员"; // 招募会员下拉列表样式切换
  tabsDetailshow: boolean = false; // 招募会员下拉列表显示与否
  tableTitle: any = "全部会员";
  tabsDetailshowTitle: boolean = true;

  tabsDetailshowsale: boolean = false;
  tabsIndexdetail2: any = 0; // 销量下拉列表样式切换
  tabsDetailshow2: boolean = false; // 销量下拉列表显示与否
  scaleTitle = "全部系列";
  scaleTitle2 = "全部";
  tabsDetailshowsaleTitle: boolean = false;
  scaleTitleId: any; //系列ID

  tabsIndexdetail3: number = 0; // 销量下拉列表样式切换
  tabsDetailshow3: boolean = false; // 销量下拉列表显示与否
  allData: string = "全部"; // 一二段是否
  selectVal = null;//搜索月份
  KPIList = [];
  kpititleName: boolean = false;
  kpititleName1: boolean = false;
  KPIObj = {
    num1: 0,
    num2: 0,
    num3: 0,
    num4: 0,
    num5: 0,
    num6: 0,
    num7: 0,
    num9: 0,
    num10: 0,
    num8: 0,
  };

  // NTS/retail  显示标题定义
  day5: any = {};
  day6: any = {};
  day7: any = {};
  day8: any = {};
  day9: any = {};
  day10: any = {};
  day11: any;
  day12: any;
  day13: any;
  day14: any;
  day15: any;
  day16: any;
  isSummaryKPI: boolean = false;
  pgId: string = null;
  storeId: string = null;
  newCustomerList: any = [];//新客列表
  isNTSFlag: boolean = false;
  NTSObj: any = {};//NTS 对象 2020-06-01新加
  _curr_ConfigName: string;
  constructor(
    private platform: Platform,
    private http: HttpCustomerService,
    private activaRouter: ActivatedRoute,
    private router: Router,
    private msg: MessageclientService,
    private com: CommonService,
    public baseService: BaseCase,
    public base: BaseModal
  ) {
    super();
    this.pageName = this.activaRouter.snapshot.paramMap.get('ConfigName');
    console.log(this.com.TenTime, "max");
    this.max = this.com.TenTime;
    this.pgId = this.com.GetAccount.Id;
    const _paramId = this.activaRouter.snapshot.paramMap.get("id");
    const _date = new Date();
    const _month = _date.getMonth() + 1;
    this.selectVal = _date.getFullYear() + "-" + (_month < 10 ? ("0" + _month) : _month);
    if (_paramId) {
      const _paramArr = _paramId.split("&");
      if (_paramArr.length > 0 && _paramArr[0] == "summaryKPI" && _paramArr[1] && _paramArr[2]) {
        const _salesSummaryKpiDate = localStorage.getItem("salesSummaryKpiDate");
        if (_salesSummaryKpiDate) {
          this.selectVal = _salesSummaryKpiDate;
        }
        this.pgId = _paramArr[1];
        this.storeId = _paramArr[2];
      }
    }
    this.LoadKPIData();
    this.loadNewCustomerList();
    let accbutype = this.com.GetStorageKey("account");
    let retailShow: any;
    console.log("身份显示")
    console.log(accbutype.BuType);
    retailShow = accbutype.BuType;
    if (retailShow == "NTS") {
      this.kpititleName = true;
      this.kpititleName1 = false;
      //只有nts 时显示， ww
      this.isNTSFlag = true;
      this.NTSObj["MM_Volume"] = 0;
      this.NTSObj["Zhongshi_Volume"] = 0;
      this.NTSObj["BMS_Volume"] = 0;
      this.NTSObj["Non_Volume"] = 0;
    }
    if (retailShow == "Retail") {
      console.log(retailShow);
      this.kpititleName = false;

      this.kpititleName1 = true;
    }
     if(retailShow == "GTBBS"){
      console.log(retailShow);
      this.kpititleName = false;

      this.kpititleName1 = true;
    }

  }

  /**
   * 搜索
   */
  searchEvent() {
    this.LoadKPIData();
    this.LoadData(1);
    this.loadNewCustomerList();
  }

  /**
   * 选择日期
   * @param $event 
   */
  dateChange($event) {
    let that = this;
    that.selectVal = $event.target.value || "";
    that.LoadKPIData();
    that.LoadData(1);
  }

  /**
   * 切换tabs
   * @param n 
   */
  tabsEvent(n) {
    const that = this;
    that.tabsIndex = n;
    // that.dataArrayList = [];
    // that.LoadData(1);
    switch (n) {
      case 0:
        // that.tabsDetailshow = that.tabsDetailshow?false:true;
        // that.tabsDetailshowsale = false;
        that.tabsDetailshowsaleTitle = false;
        that.tabsDetailshowTitle = true;

        that.tabsDetailshow2 = false;
        that.tabsDetailshow3 = false;
        that.tabsIndexdetail = "全部会员";
        that.tableTitle = "全部会员";
        //   that.dataArrayList = [];
        // that.LoadData(1);
        break;
      case 1:
        that.tabsDetailshow = false;
        that.tabsDetailshowTitle = false;
        that.tabsDetailshowsaleTitle = true;
        that.tabsIndexdetail2 = 0;
        that.tabsIndexdetail3 = 0;
        that.scaleTitle = "全部系列";
        that.scaleTitle2 = "全部";
        // that.dataArrayList = [];
        // that.LoadData(1);


        // if (that.tabsDetailshowsale) {
        //   that.tabsDetailshowsale = false;
        //   that.tabsDetailshow3 = false;
        //   that.tabsDetailshow2 = false;
        //   console.log(that.tabsDetailshow3)
        // }else{
        //   that.tabsDetailshowsale = true;
        //   that.tabsDetailshow3 = true;
        //   that.tabsDetailshow2 = true;
        // }
        // that.tabsDetailshow3 = false;
        break;
      case 2:
        that.tabsDetailshow = false;
        that.tabsDetailshowTitle = false;
        that.tabsDetailshowsaleTitle = false;
        that.tabsDetailshowsale = false;
        break;
      // case 2:
      //   that.tabsDetailshow = false;
      //   that.tabsDetailshow2 = false;
      //   that.tabsDetailshow3 =  that.tabsDetailshow3?false:true;
      // break;
    }
    that.dataArrayList = [];
    that.LoadData(1);

  }
  /**
   * 切换下拉框 招募会员
   * @param event 
   * @param item 
   */
  tabsDetail(num) {
    const that = this;
    that.tabsIndexdetail = num;
    that.tableTitle = that.tabsIndexdetail;

    that.tabsDetailshow = false;
    that.dataArrayList = [];
    that.LoadData(1);

  }
  /**
  * 切换下拉框 招募会员
  * @param event 
  * @param item 
  */
  tabsDetail2(aID, Aname) {

    const that = this;
    that.tabsIndexdetail2 = aID;
    that.scaleTitle = Aname;
    // that.scaleTitleId = aID;
    that.tabsDetailshow2 = false;
    if (that.tabsDetailshow2 == false && that.tabsDetailshow3 == false) {
      that.tabsDetailshowsale = false;
    }
    that.dataArrayList = [];
    that.LoadData(1);
    // this.dataArrayList = [];
    // this.LoadData(1);

  }
  /**
  * 切换下拉框 招募会员
  * @param event 
  * @param item 
  */
  tabsDetail3(num, name) {
    const that = this;
    console.log(name);

    that.tabsIndexdetail3 = num;
    // that.scaleTitle2 = num;
    that.scaleTitle2 = name;

    that.tabsDetailshow3 = false;
    // this.dataArrayList = [];
    // this.LoadData(1);
    if (that.tabsDetailshow2 == false && that.tabsDetailshow3 == false) {
      that.tabsDetailshowsale = false;
    }
    that.dataArrayList = [];
    that.LoadData(1);
  }
  /**
   * 招募会员标签 显示下拉与否
   */
  memberRecruitment() {
    const that = this;
    that.tabsDetailshow = that.tabsDetailshow ? false : true;
    // that.tabsDetailshowsaleTitle = false;
    that.tabsDetailshowsale = false;
    that.tabsDetailshowsaleTitle = false;
    that.tabsDetailshowTitle = true;

  }
  scaleClic() {
    const that = this;
    // that.tabsDetailshow2 = true;
    that.tabsDetailshow2 = that.tabsDetailshow2 ? false : true;
    that.tabsDetailshow = false;
    that.tabsDetailshowTitle = false;
    that.tabsDetailshowsaleTitle = true;
    that.tabsDetailshowsale = true;
    console.log(that.tabsDetailshow2);
    that.tabsDetailshow3 = false;
    that.loadList();


  }
  scaleClictwo() {
    const that = this;
    // that.tabsDetailshow2 = true;
    that.tabsDetailshow3 = that.tabsDetailshow3 ? false : true;
    that.tabsDetailshow = false;
    that.tabsDetailshowTitle = false;
    that.tabsDetailshowsaleTitle = true;
    that.tabsDetailshowsale = true;
    console.log(that.tabsDetailshow2);
    that.tabsDetailshow2 = false;
  }
  EventLink(event, item) {
    // console.log(item);
    // localStorage.setItem("information", JSON.stringify(item));
    // this.com.setHistoryUrl();
    // this.router.navigate([event.url + item.id.value + "&" + this.com.getNowDatetime]);
  }
  loadMoreData(event) {
    let that = this;
    if (that.RecordCount == that.dataArrayList.length) {
      if (that.infiniteScroll) {
        that.infiniteScroll.disabled = true;
      }

    } else {
      that.PageNumber++;
      this.LoadData(that.PageNumber);
    }
  }
  LoadKPIData() {
    let that = this;
    const PageName = that.activaRouter.snapshot.paramMap.get('ConfigName');
    let body = new WebParameterContext();
    body.Account = that.com.GetAccount;
    body.ConfigName = "MyKpiXML";
    body.OpType = "query";
    body.ConfigType = "view";
    body.RowsPerPage = app.RowsPerPage;
    body.PageNumber = 1;
    body.Client.PageName = PageName;
    body.Client.ApiType = "Element";
    body.Client.Name = that.element.name;
    body.Client.ClientType = 2;
    if (that.platform.is("android")) {
      body.Client.ClientType = 0;
    } else if (that.platform.is("ios")) {
      body.Client.ClientType = 1;
    }

    //获取商店id id 拼接数据
    let idArry: Array<any> = new Array<any>();
    // let isdz:boolean = false;//是否督导
    // that.com.GetAccount.Roles.forEach(role=>{
    //   if(role.Code==""){
    //     isdz=true;
    //   }

    // });
    idArry.push(that.pgId);
    let infoArry = that.com.GetStorageKey("pginfo") || {};
    if (infoArry.a_FK_Store_ID) {
      idArry.push(infoArry.a_FK_Store_ID);
    }

    console.log("显示显示显示++++++++++")
    console.log(idArry);
    let _Obj = {
      "a_ID": idArry,
      "a_Year": that.selectVal.split("-")[0],
      "a_Month": that.selectVal.split("-")[1]
    };
    body.RequestBody = JSON.stringify(_Obj);
    that.http.post(app.DEFAULTURL, body).then(data => {
      if (data.ResponseMessage.Success) {
        that.day11 = 0;
        that.day12 = 0;
        that.day13 = 0;
        that.day14 = 0;
        that.day15 = 0;
        that.day16 = 0;
        console.log(data);
        that.KPIObj = {
          num1: 0,
          num2: 0,
          num3: 0,
          num4: 0,
          num5: 0,
          num6: 0,
          num7: 0,
          num8: 0,
          num9: 0,
          num10: 0,
        };
        that.KPIList = data.Status.Datas;
        console.log("显示显示显示显示++++++++++++++++++++++++++++++++")
        console.log(data.Status.Datas)
        console.log(data.Status.Datas.length);
        let arrayList: Array<any> = new Array<any>();
        let isarray: boolean = false;
        if (data.Status.Datas.length > 0) {
          data.Status.Datas.forEach(item => {
            // if(item.a_Code == '1001'){
            //   that.KPIObj["num1"] = item.a_SumPrice;
            // }else if(item.a_Code == '1002'){
            //   that.KPIObj["num2"] = item.a_Num;
            // }else if(item.a_Code == '1003'){
            //   that.KPIObj["num3"] = item.a_Num;
            // }else if(item.a_Code == '1004'){
            //   that.KPIObj["num4"] = item.a_Num;
            // }
            isarray = false;
            if (arrayList.length <= 0) {
              arrayList.push(item);
            } else {
              arrayList.forEach(newitem => {
                if (newitem.a_Code == item.a_Code) {
                  isarray = true;
                  newitem.a_Num += item.a_Num;
                  newitem.a_Volume += item.a_Volume;
                }
              });
              if (!isarray) {
                arrayList.push(item);
              }
            }
          });
          console.log(arrayList, "log");
          arrayList.forEach(item => {
            let num: number = Number.parseInt(item.a_Volume);

            let num2: number = Number.parseInt(item.a_Num);
            let num4: number = 0;
            if (num == 0) {//如果分母为零分子不为零则为100%;
              if (num2) {
                num4 = 100;
              } else {
                num4 = 0;
              }
            } else {
              num4 = (num2 / num) * 100;
            }
            let num3: any = num4.toFixed(2);
            //NTS身份显示
            if (item.a_Code == "2001") {
              that.day5 = item;
              that.day11 = item.a_SumPrice;
              console.log("显示显示显示显示")
              console.log(that.day5);
              that.KPIObj["num5"] == item.a_Num;
            }
            if (item.a_Code == "2002") {
              that.day6 = item;
              that.day12 = item.a_SumPrice;
              that.KPIObj["num6"] == item.a_Num;
            }
            if (item.a_Code == "2003") {
              that.day7 = item;
              that.day13 += Number.parseFloat(num3);
              that.KPIObj["num7"] == item.a_Num;
            }
            if (item.a_Code == "2004") {
              that.day8 = item;
              that.day14 += Number.parseFloat(num3);
              that.KPIObj["num8"] == item.a_Num;
            }
            //retail
            if (item.a_Code == "2006") {//新客
              that.day9 = item;
              that.day15 = item.a_SumPrice;
              that.KPIObj["num9"] == item.a_Num;
              // this.echartBind1(num3);
            }
            if (item.a_Code == "2005") {//销量（元）
              that.day10 = item;
              that.day16 = item.a_SumPrice;
              that.KPIObj["num10"] == item.a_Num;
              // this.echartBind2(num3);
            }
          })
        }


        //NTS w
        if (data && data.Status && data.Status.Datas) {
          let _find = data.Status.Datas;
          if (_find.find(n => n.a_Code == "2001")) {
            that.NTSObj["MM_Volume"] = _find.find(n => n.a_Code == "2001")["a_Volume"] || 0;
          }
          if (_find.find(n => n.a_Code == "2002")) {
            that.NTSObj["Zhongshi_Volume"] = _find.find(n => n.a_Code == "2002")["a_Volume"] || 0;
          }
          if (_find.find(n => n.a_Code == "2003")) {
            that.NTSObj["BMS_Volume"] = _find.find(n => n.a_Code == "2003")["a_Volume"] || 0;
          }
          if (_find.find(n => n.a_Code == "2004")) {
            //non-bms
            that.NTSObj["Non_Volume"] = _find.find(n => n.a_Code == "2004")["a_Volume"] || 0;
          }
        }
      }
    }).catch(error => {
      that.apiObj['msg'] = error.ResponseMessage.ErrorMessage;
      console.log(error);
    });
  }
  /**
   * 获取产品系列列表
   */
  loadList() {
    let that = this;
    const PageName = that.activaRouter.snapshot.paramMap.get('ConfigName');
    let body = new WebParameterContext();
    body.Account = that.com.GetAccount;
    body.ConfigName = "TBProductSeriesXML";
    body.OpType = "query";
    body.ConfigType = "view";
    body.RowsPerPage = app.RowsPerPage;
    body.PageNumber = 1;
    body.Client.PageName = PageName;
    body.Client.ApiType = "Element";
    body.Client.Name = that.element.name;
    body.Client.ClientType = 2;
    if (that.platform.is("android")) {
      body.Client.ClientType = 0;
    } else if (that.platform.is("ios")) {
      body.Client.ClientType = 1;
    }
    that.http.post(app.DEFAULTURL, body).then(data => {
      if (data.ResponseMessage.Success) {

        that.dataroDuctSeriesList = data.Status.Datas;

      }
    }).catch(error => {
      console.log(error);
    });
  }

  LoadData(PageNumber) {
    let that = this;
    // console.log("1008611");
    that.PageNumber = PageNumber;
    const _index = that.tabsIndex;
    if (PageNumber == 1) {
      that.loading = false;
      that.apiObj['status'] = false;
      that.apiObj['msg'] = '';
    }
    // console.log(that.element);
    const PageName = that.activaRouter.snapshot.paramMap.get('ConfigName');
    let body = new WebParameterContext();
    body.Account = that.com.GetAccount;
    body.ConfigName = "MyKpiXML";
    body.OpType = "query";
    body.ConfigType = "view";
    body.RowsPerPage = app.RowsPerPage;
    body.PageNumber = PageNumber;
    body.Client.PageName = PageName;
    body.Client.ApiType = "Element";
    body.Client.Name = that.element.name;
    body.Client.ClientType = 2;
    if (that.platform.is("android")) {
      body.Client.ClientType = 0;
    } else if (that.platform.is("ios")) {
      body.Client.ClientType = 1;
    }
    const _year = that.selectVal.split("-")[0];
    const _month = that.selectVal.split("-")[1];
    let day = new Date(_year, _month, 0);
    let startDate = _year + "-" + _month + "-" + "01" + " 00:00:00";
    let endDate = _year + "-" + _month + "-" + day.getDate() + " 23:59:59";
    let _Obj = {};
    let tableNumbe = 0;
    let scaleNumbe = '';

    switch (that.tabsIndex) {

      case 0:

        body.ConfigName = "NewMember";
        if (that.tableTitle == "全部会员") {
          tableNumbe = 0;
        } else if (that.tableTitle == "妈妈新客") {
          tableNumbe = 1;
        } else if (that.tableTitle == "忠实会员") {
          tableNumbe = 2;
        } else if (that.tableTitle == "幼儿新客") {
          tableNumbe = 3;
        }
        _Obj = {
          "Type": 1,
          "UserId": that.pgId,
          "StoreID": that.storeId,
          "CreateDate": that.selectVal + "-01",
          "MenberType": tableNumbe
        };
        break;
      case 1:
        body.ConfigName = "NewMember";
        console.log("商店id++++++")
        console.log(that.storeId);
        _Obj = {
          "Type": 2,
          "UserId": that.pgId,
          "StoreID": that.storeId,
          "CreateDate": that.selectVal + "-01",
          "ProductSeriesId": that.tabsIndexdetail2 == 0 ? "" : that.tabsIndexdetail2,
          "StageName": that.tabsIndexdetail3

        }
        break;
      case 2:
        body.ConfigName = "AttendanceManagement";
        _Obj = {
          "a_FK_SystemUser_ID": that.pgId,
          "a_SNStartDate": that.com.BetweenDate(startDate, endDate)
        };
        break;
      case 3:
        body.ConfigName = "NewMember";
        _Obj = {
          "Type": 3,
          "UserId": that.pgId,
          "StoreID": that.storeId,
          "CreateDate": that.selectVal + "-01"
        };
        break;
    }
    if (!that.storeId) {
      delete _Obj["StoreID"];
    }

    body.RequestBody = JSON.stringify(_Obj);
    that.http.post(app.DEFAULTURL, body).then(data => {

      if (_index != that.tabsIndex) {
        return;
      }

      /****判断是否第一页begin****/
      if (PageNumber == 1) {
        that.dataArrayList = [];
        that.apiObj['status'] = data.ResponseMessage.Success;
        that.apiObj['msg'] = data.ResponseMessage.ErrorMessage;
        that.loading = true;
      } else {
        if (that.infiniteScroll) {
          that.infiniteScroll.complete();
        }

      }
      /****判断是否第一页end****/
      if (data.ResponseMessage.Success) {
        if (PageNumber != 1) {
          that.dataArrayList = that.dataArrayList.concat(data.Status.Datas);
        } else {
          that.dataArrayList = data.Status.Datas;
        }
        that.dataArrayList.forEach(function (item) {
          if (that.tabsIndex == 0) {
            if (item["Name"]) {
              item["Name"] = that.com.FormatName(item["Name"]);
            }
            if (item["TelPhone"]) {
              item["TelPhone"] = that.com.PhoneNum(item["TelPhone"]);
            }
          }
          if (item["a_SNStartDate"]) {
            item["a_SNStartDate"] = item["a_SNStartDate"].toString().replace(/-/g, "/");
          }
          if (item["SaleDay"]) {
            item["SaleDay"] = item["SaleDay"].toString().replace(/-/g, "/");
          }
          if (item["Code"]) {
            item["Code"] = item["Code"].toString().replace(/-/g, "/");
          }
          if (that.tabsIndex == 2) {//考勤列表
            if (!item["a_StartDate"] && !item["a_EndDate"]) {
              item["a_WorkState"] = "未上班";
            } else if (item["a_StartDate"] && !item["a_EndDate"]) {
              item["a_WorkState"] = "已上班";
            } else if (item["a_StartDate"] && item["a_EndDate"]) {
              item["a_WorkState"] = "已下班";
            }
          }
        })



        // data.Status.Datas.forEach(function (item) {
        //   let objfield = {};
        //   that.element.selectItemList.selectItem.forEach((element, index) => {
        //     if (element.bindingField) {
        //       objfield[element.bindingField] = { "value": item[element.field], "text": element.text };
        //     }
        //   });
        //   that.dataArrayList.push(objfield);
        //   // console.log(that.element.selectItemList.selectItem);
        //   //console.log(that.dataArrayList);
        // });
        /****上拉加载数据begin****/
        that.RecordCount = data.Status.RecordCount;
        if (that.RecordCount == data.Status.Datas.length || that.RecordCount == that.dataArrayList.length) {
          // that.infiniteScroll.disabled = true;
          if (that.infiniteScroll) {
            that.infiniteScroll.disabled = true;
          }
        } else {
          if (that.infiniteScroll) {
            that.infiniteScroll.disabled = false;
          }
        }
        /****上拉加载数据end****/
      }

    }).catch(error => {
      that.dataArrayList = [];
      that.apiObj['status'] = false;
      that.apiObj['msg'] = error.ResponseMessage.ErrorMessage;
      that.loading = true;
      console.log(error);
    });
  }

  loadNewCustomerList() {
    let that = this;
    const PageName = that.activaRouter.snapshot.paramMap.get('ConfigName');
    let body = new WebParameterContext();
    body.Account = that.com.GetAccount;
    body.ConfigName = "NewMember";
    body.OpType = "query";
    body.ConfigType = "view";
    body.RowsPerPage = app.RowsPerPage;
    body.PageNumber = 1;
    body.Client.PageName = PageName;
    body.Client.ApiType = "Element";
    body.Client.Name = that.element.name;
    body.Client.ClientType = 2;
    let _Obj = {
      "Type": 4,
      "UserId": that.pgId,
      "StoreID": that.storeId,
      "CreateDate": that.selectVal + "-01"
    };
    if (!that.storeId) {
      delete _Obj["StoreID"];
    }
    body.RequestBody = JSON.stringify(_Obj);
    that.http.post(app.DEFAULTURL, body).then(data => {
      if (data.ResponseMessage.Success) {
        that.newCustomerList = data.Status.Datas;
        that.newCustomerList.sort(function (a, b) {
          if (a["code"] > b["code"]) {
            return -1;
          } else {
            return 1;
          }
        });
      }
    }).catch(error => {
      console.log(error);
    });
  }

  //招募会员跳转到会员足迹
  hrefHuiYuanZuJi(vipId: string) {

    this.LoadVip(vipId)
    // this.router.navigate(["/tabs/contact/WCustomerDetail/view/"+vipId + "&" + this.com.getNowDatetime]);

  }

  LoadVip(vipId: string) {
    let item = {};
    let that = this;
    console.log("1008611");
    that.PageNumber = 1;
    // console.log(that.element);
    const PageName = that.activaRouter.snapshot.paramMap.get('ConfigName');
    let body = new WebParameterContext();
    body.Account = that.com.GetAccount;

    body.ConfigName = "MemberManage";
    body.OpType = "query";
    body.ConfigType = "view";
    body.RowsPerPage = app.RowsPerPage;
    // body.RowsPerPage = 2;
    body.PageNumber = 1;
    body.Client.PageName = PageName;
    body.Client.ApiType = "Element";
    body.Client.Name = that.element.name;
    body.Client.ClientType = 2;
    if (that.platform.is("android")) {
      body.Client.ClientType = 0;
    } else if (that.platform.is("ios")) {
      body.Client.ClientType = 1;
    }
    body.RequestBody = { "Type": 6, "FK_MembersInfoManagement_ID": vipId };
    body.RequestBody = JSON.stringify(body.RequestBody);
    that.http.post(app.DEFAULTURL, body).then(data => {
      /****判断是否第一页end****/
      if (data.ResponseMessage.Success) {
        if (data.Status.Datas && data.Status.Datas.length > 0) {
          let beforeData = data.Status.Datas[0];
          item["name"] = { "value": that.com.FormatName(beforeData["name"]), "text": "name" };
          item["memberstype"] = { "value": beforeData["MembersType"], "text": "name" };
          item["wechatnickname"] = { "value": beforeData["WeChatNickName"], "text": "name" };
          item["phone"] = { "value": that.com.PhoneNum(beforeData["telPhone"]), "text": "name" };
          item["mamamemberstate"] = { "value": beforeData["MamaMemberState"], "text": "name" };
          item["s3memberstate"] = { "value": beforeData["S3MemberState"], "text": "name" };
          item["imfmemberstate"] = { "value": beforeData["IMFMemberState"], "text": "name" };
        }
        localStorage.setItem("information", JSON.stringify(item));
        // this.router.navigate(["/tabs/contact/WCustomerDetail/view/" + vipId + "&" + this.com.getNowDatetime]);
        this.com.Go("/tabs/contact/WCustomerDetail/view/" + vipId + "&" + this.com.getNowDatetime);
        // data.Status.Datas.forEach(function (item) {
        //   let objfield = {};
        //   let arrType=[];
        //   that.element.selectItemList.selectItem.forEach((element, index) => {
        //     if (element.bindingField) {
        //       objfield[element.bindingField] = { "value": item[element.field], "text": element.text };
        //     }
        //     if((element.bindingField == 'birthday' || element.bindingField == 'pre_Date') && objfield[element.bindingField].value){
        //       objfield[element.bindingField].value = objfield[element.bindingField].value.toString().replace(/-/g,"/");
        //     }
        //     // if(element.formatter && element.formatter == "type"){
        //     //   if(objfield[element.bindingField].value&&objfield[element.bindingField].value){
        //     //     if(objfield[element.bindingField]=="typeall")
        //     //     {
        //     //       delete objfield[element.bindingField];
        //     //     }
        //     //   arrType.push(element.text);
        //     //   }
        //         // objfield[element.bindingField] = { "value": item[element.field], "text": element.text };
        //     // }
        //     that.com.CustomerTag(element,objfield,arrType);//获取所有标签
        //   });
        //   if(objfield["name"] && objfield["name"].value){
        //     objfield["name"].value=that.com.FormatName(objfield["name"].value);
        //   }
        //   if(objfield["phone"]){
        //     if(objfield["phone"].value){
        //       objfield["phone"].value=that.com.PhoneNum(objfield["phone"].value);
        //     }
        //   }
        //   if(objfield["birthday"]){
        //     if(objfield["birthday"].value){
        //       if(objfield["birthday"].value.split(" ")[0]){
        //         objfield["birthday"].value=objfield["birthday"].value.split(" ")[0];
        //       }
        //     }
        //   }
        //   that.dataArrayList.push(objfield);
        //   console.log("selectItem",that.element.selectItemList.selectItem);
        //   console.log("dataArrayList",that.dataArrayList);
        // });

        /****上拉加载数据end****/
      }

    }).catch(error => {
      that.apiObj['status'] = false;
      that.apiObj['msg'] = error.ResponseMessage.ErrorMessage;
      that.loading = true;
      console.log(error);
    });
  }
}
